function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import { FormattedMessage, useIntl } from 'react-intl';
import SongControls from '../song_requests/SongControls';
import { Box, Flex, Icon, IconButton, MenuButton, useBreakpointValue, useDisclosure } from '@chakra-ui/react';
import { SongRequestProvider } from '@/types/server';
import { clearSongRequestQueue, createPlaylistItem, createSongRequest, createSongRequestFromPlaylistItem, deletePlaylistItem, deleteSongRequest, getPlaylist, getSongRequestQueue, getSongRequestSettings, playSongRequestQueueItem, reorderSongRequestQueue, updateSongRequestSettings } from '@/actions/SongRequestActions';
import useChannelStore from '@/stores/ChannelStore';
import InputModal from '@/components/InputModal';
import { SocketContext } from '../providers/SocketProvider';
import { useNavigate } from 'react-router';
import { NativeEventNames, WebRoutes } from '@/utils/constants';
import CurrentSongRequestDescription from '../song_requests/CurrentSongRequestDescription';
import { hex2rgba } from '@/utils/color';
import useCurrentSongRequestOutputFile from '@/hooks/useCurrentSongRequestOutputFile';
import Heading from '../Heading';
import { Helmet } from 'react-helmet';
import nativeEvents, { sendNativeEvent } from '@/lib/native-events';
import { PlaylistSortType, SortDirections } from '@/types/client';
import SongRequestsTable from '../song_requests/SongRequestTable';
import { useDebouncedCallback } from 'use-debounce';
import SongSettingsMenu from '../song_requests/SongSettingsMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faEllipsisV, faForwardStep, faMusic, faPause, faPlay, faTrash, faVolumeHigh } from '@fortawesome/free-solid-svg-icons';
import useNotification from '@/hooks/useNotification';
import PlayerEmbed from '../song_requests/PlayerEmbed';
function serializeSongTrackId(song) {
    return "".concat(song.track.provider, ":").concat(song.track.providerId);
}
function SongRequests() {
    var navigate = useNavigate();
    var intl = useIntl();
    var playerRef = React.useRef(null);
    var handleErrorRef = React.useRef(null);
    var nextSongRequestRef = React.useRef(null);
    var socketClient = useContext(SocketContext);
    var portalRef = React.useRef(null);
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var bannerRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(0), 2), bannerBottom = _React_useState[0], setBannerBottom = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(window.innerHeight), 2), windowHeight = _React_useState1[0], setWindowHeight = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(false), 2), closedSongRequestDisabledModal = _React_useState2[0], setClosedSongRequestDisabledModal = _React_useState2[1];
    var _React_useState3 = _sliced_to_array(React.useState(false), 2), isShuffling = _React_useState3[0], setIsShuffling = _React_useState3[1];
    var notification = useNotification();
    var deleteSongRequestModal = useDisclosure();
    var addSongRequestModal = useDisclosure();
    var clearQueueModal = useDisclosure();
    var _React_useState4 = _sliced_to_array(React.useState(null), 2), songRequests = _React_useState4[0], setSongRequests_ = _React_useState4[1];
    var _React_useState5 = _sliced_to_array(React.useState(null), 2), selectedSong = _React_useState5[0], setSelectedSong = _React_useState5[1];
    var _React_useState6 = _sliced_to_array(React.useState(null), 2), pendingCurrentSongRequest = _React_useState6[0], setPendingCurrentSongRequest = _React_useState6[1];
    var _React_useState7 = _sliced_to_array(React.useState(null), 2), currentSongRequest = _React_useState7[0], setCurrentSongRequest = _React_useState7[1];
    var _React_useState8 = _sliced_to_array(React.useState([]), 2), songRequestHistory = _React_useState8[0], setSongRequestHistory = _React_useState8[1];
    var _React_useState9 = _sliced_to_array(React.useState(null), 2), currentSongRequestPlaylistItem = _React_useState9[0], setCurrentSongRequestPlaylistItem = _React_useState9[1];
    var _React_useState10 = _sliced_to_array(React.useState(false), 2), currentSongRequestPlaylistItemLoading = _React_useState10[0], setCurrentSongRequestPlaylistItemLoading = _React_useState10[1];
    var _React_useState11 = _sliced_to_array(React.useState(null), 2), playlist = _React_useState11[0], setPlaylist = _React_useState11[1];
    var _React_useState12 = _sliced_to_array(React.useState(0), 2), playlistOffset = _React_useState12[0], setPlaylistOffset = _React_useState12[1];
    var _React_useState13 = _sliced_to_array(React.useState(true), 2), playlistHasMore = _React_useState13[0], setPlaylistHasMore = _React_useState13[1];
    var _React_useState14 = _sliced_to_array(React.useState(Date.now()), 2), playlistRandomSeed = _React_useState14[0], setPlaylistRandomSeed = _React_useState14[1];
    var playlistLoadingRef = React.useRef(false);
    var _React_useState15 = _sliced_to_array(React.useState(false), 2), playlistEmpty = _React_useState15[0], setPlaylistEmpty = _React_useState15[1];
    var _React_useState16 = _sliced_to_array(React.useState(null), 2), settings = _React_useState16[0], setSettings = _React_useState16[1];
    var _React_useState17 = _sliced_to_array(React.useState(false), 2), isPlaying = _React_useState17[0], setIsPlaying_ = _React_useState17[1];
    var _React_useState18 = _sliced_to_array(React.useState(false), 2), isBuffering = _React_useState18[0], setIsBuffering = _React_useState18[1];
    var _React_useState19 = _sliced_to_array(React.useState(0), 2), position = _React_useState19[0], setPosition = _React_useState19[1];
    var _React_useState20 = _sliced_to_array(React.useState(1), 2), duration = _React_useState20[0], setDuration = _React_useState20[1];
    var _React_useState21 = _sliced_to_array(React.useState(false), 2), muted = _React_useState21[0], setMuted = _React_useState21[1];
    var setIsPlaying = React.useCallback(function(playing) {
        if (playing) {
            var _playerRef_current;
            (_playerRef_current = playerRef.current) === null || _playerRef_current === void 0 ? void 0 : _playerRef_current.play();
        } else {
            var _playerRef_current1;
            (_playerRef_current1 = playerRef.current) === null || _playerRef_current1 === void 0 ? void 0 : _playerRef_current1.pause();
        }
        setIsPlaying_(playing);
    }, []);
    var song = pendingCurrentSongRequest !== null && pendingCurrentSongRequest !== void 0 ? pendingCurrentSongRequest : currentSongRequest;
    var setSongRequests = React.useCallback(function(songRequestsOrCallback) {
        setSongRequests_(function(prev) {
            var songRequests = prev;
            if (typeof songRequestsOrCallback === 'function') {
                songRequests = songRequestsOrCallback(songRequests);
            } else {
                songRequests = songRequestsOrCallback;
            }
            if (songRequests.every(function(song, index) {
                return song._position === index + 1;
            })) {
                return songRequests;
            }
            return songRequests.map(function(song, index) {
                return _object_spread_props(_object_spread({}, song), {
                    _position: index + 1
                });
            });
        });
    }, [
        setSongRequests_
    ]);
    React.useEffect(function() {
        if (!closedSongRequestDisabledModal && (settings === null || settings === void 0 ? void 0 : settings.enabled) === true) {
            setClosedSongRequestDisabledModal(true);
        }
    }, [
        closedSongRequestDisabledModal,
        settings === null || settings === void 0 ? void 0 : settings.enabled
    ]);
    React.useEffect(function() {
        var updateWindowHeight = function updateWindowHeight() {
            setWindowHeight(window.innerHeight);
        };
        window.addEventListener('resize', updateWindowHeight);
        return function() {
            return window.removeEventListener('resize', updateWindowHeight);
        };
    }, []);
    var onSeek = React.useCallback(function(position) {
        if (playerRef.current == null) {
            return;
        }
        playerRef.current.seek(position);
        playerRef.current.play();
        setPosition(position);
    }, [
        playerRef
    ]);
    var loadPlaylist = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param) {
            var _param_sortBy, sortBy, _param_sortDirection, sortDirection, _param_seed, seed, reset, _ref, newPlaylist, newOffset, total;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_sortBy = param.sortBy, sortBy = _param_sortBy === void 0 ? PlaylistSortType.RANDOM : _param_sortBy, _param_sortDirection = param.sortDirection, sortDirection = _param_sortDirection === void 0 ? SortDirections.DESC : _param_sortDirection, _param_seed = param.seed, seed = _param_seed === void 0 ? playlistRandomSeed : _param_seed;
                        if (channel == null || playlistLoadingRef.current) {
                            return [
                                2
                            ];
                        }
                        reset = playlistRandomSeed !== seed;
                        if (!reset && !playlistHasMore) {
                            return [
                                2
                            ];
                        }
                        playlistLoadingRef.current = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            getPlaylist(channel._id, {
                                limit: 25,
                                offset: reset ? 0 : playlistOffset,
                                sort_by: sortBy,
                                direction: sortDirection !== null && sortDirection !== void 0 ? sortDirection : undefined,
                                seed: seed
                            })
                        ];
                    case 2:
                        _ref = _state.sent(), newPlaylist = _ref.playlist, newOffset = _ref.offset, total = _ref.total;
                        setPlaylist(function(prev) {
                            return reset ? newPlaylist : _to_consumable_array(prev !== null && prev !== void 0 ? prev : []).concat(_to_consumable_array(newPlaylist));
                        });
                        setPlaylistOffset(newOffset + newPlaylist.length);
                        setPlaylistHasMore(total > newOffset + newPlaylist.length);
                        setPlaylistRandomSeed(seed);
                        setPlaylistEmpty(newPlaylist.length === 0);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        playlistLoadingRef.current = false;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        playlistRandomSeed,
        channel,
        playlistHasMore,
        playlistOffset
    ]);
    React.useEffect(function() {
        if ((channel === null || channel === void 0 ? void 0 : channel._id) == null) {
            return;
        }
        setSongRequestHistory([]);
        getSongRequestSettings(channel._id).then(function(param) {
            var settings = param.settings;
            return setSettings(settings);
        }).catch(console.error);
        getSongRequestQueue(channel._id).then(function(param) {
            var queue = param.queue, current = param.current;
            setSongRequests(queue);
            setCurrentSongRequest(current);
        });
        loadPlaylist({
            seed: Date.now()
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel === null || channel === void 0 ? void 0 : channel._id
    ]);
    var deleteSongRequestQueue = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (channel == null || songRequests == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        clearSongRequestQueue(channel._id)
                    ];
                case 1:
                    _state.sent();
                    setSongRequests([]);
                    setCurrentSongRequest(null);
                    return [
                        2
                    ];
            }
        });
    }), [
        channel,
        setSongRequests,
        songRequests
    ]);
    var nextSongRequestInternal = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _songRequests, newCurrentSongRequest, newSongRequests, _, _nextSongRequestRef_current, newPlaylist, newCurrentSongRequest1, songRequest, queueItem, _1, _nextSongRequestRef_current1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (channel == null || songRequests == null || playlist == null || pendingCurrentSongRequest != null) {
                        return [
                            2
                        ];
                    }
                    if (!(songRequests.length > 0)) return [
                        3,
                        5
                    ];
                    _songRequests = _to_array(songRequests), newCurrentSongRequest = _songRequests[0], newSongRequests = _songRequests.slice(1);
                    setSongRequests(newSongRequests);
                    setCurrentSongRequest(newCurrentSongRequest);
                    setCurrentSongRequestPlaylistItem(null);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        playSongRequestQueueItem(channel._id, newCurrentSongRequest._id)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _ = _state.sent();
                    notification(intl.formatMessage({
                        id: "F+RbsU",
                        defaultMessage: [
                            {
                                type: 0,
                                value: 'An error occurred loading "'
                            },
                            {
                                type: 1,
                                value: "name"
                            },
                            {
                                type: 0,
                                value: '." Skipping to the next song..'
                            }
                        ]
                    }, {
                        name: newCurrentSongRequest.track.title
                    }), {
                        status: 'error'
                    });
                    (_nextSongRequestRef_current = nextSongRequestRef.current) === null || _nextSongRequestRef_current === void 0 ? void 0 : _nextSongRequestRef_current.call(nextSongRequestRef);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        3,
                        12
                    ];
                case 5:
                    if (!(playlist.length > 0)) return [
                        3,
                        11
                    ];
                    newPlaylist = _to_consumable_array(playlist);
                    newCurrentSongRequest1 = newPlaylist.shift();
                    if ((newCurrentSongRequest1 === null || newCurrentSongRequest1 === void 0 ? void 0 : newCurrentSongRequest1.track.provider) === (currentSongRequest === null || currentSongRequest === void 0 ? void 0 : currentSongRequest.track.provider) && (newCurrentSongRequest1 === null || newCurrentSongRequest1 === void 0 ? void 0 : newCurrentSongRequest1.track.providerId) === (currentSongRequest === null || currentSongRequest === void 0 ? void 0 : currentSongRequest.track.providerId)) {
                        newCurrentSongRequest1 = newPlaylist.shift();
                    }
                    setPlaylist(newPlaylist);
                    if (newCurrentSongRequest1 == null) {
                        return [
                            2
                        ];
                    }
                    setPendingCurrentSongRequest(newCurrentSongRequest1);
                    setCurrentSongRequestPlaylistItem(newCurrentSongRequest1);
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        9,
                        ,
                        10
                    ]);
                    return [
                        4,
                        createSongRequestFromPlaylistItem(channel._id, newCurrentSongRequest1._id)
                    ];
                case 7:
                    songRequest = _state.sent();
                    return [
                        4,
                        playSongRequestQueueItem(channel._id, songRequest._id)
                    ];
                case 8:
                    queueItem = _state.sent();
                    setPendingCurrentSongRequest(null);
                    setCurrentSongRequest(queueItem);
                    return [
                        3,
                        10
                    ];
                case 9:
                    _1 = _state.sent();
                    notification(intl.formatMessage({
                        id: "F+RbsU",
                        defaultMessage: [
                            {
                                type: 0,
                                value: 'An error occurred loading "'
                            },
                            {
                                type: 1,
                                value: "name"
                            },
                            {
                                type: 0,
                                value: '." Skipping to the next song..'
                            }
                        ]
                    }, {
                        name: newCurrentSongRequest1.track.title
                    }), {
                        status: 'error'
                    });
                    setPendingCurrentSongRequest(null);
                    (_nextSongRequestRef_current1 = nextSongRequestRef.current) === null || _nextSongRequestRef_current1 === void 0 ? void 0 : _nextSongRequestRef_current1.call(nextSongRequestRef);
                    return [
                        3,
                        10
                    ];
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    setCurrentSongRequest(null);
                    _state.label = 12;
                case 12:
                    if (currentSongRequest != null) {
                        deleteSongRequest(channel._id, currentSongRequest._id).catch(function() {});
                        setSongRequestHistory(function(prev) {
                            return [
                                currentSongRequest
                            ].concat(_to_consumable_array(prev !== null && prev !== void 0 ? prev : [])).slice(0, 10);
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        channel,
        songRequests,
        playlist,
        pendingCurrentSongRequest,
        currentSongRequest,
        setSongRequests,
        notification,
        intl
    ]);
    React.useEffect(function() {
        nextSongRequestRef.current = nextSongRequestInternal;
    }, [
        nextSongRequestRef,
        nextSongRequestInternal
    ]);
    var nextSongRequest = React.useCallback(function() {
        if (nextSongRequestRef.current != null) {
            nextSongRequestRef.current();
        }
    }, [
        nextSongRequestRef
    ]);
    React.useEffect(function() {
        if (playlist == null || playlist.length > 0 || playlistEmpty) {
            return;
        }
        if (!playlistHasMore) {
            loadPlaylist({
                seed: Date.now()
            });
            return;
        }
        loadPlaylist({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        playlist,
        playlistEmpty,
        playlistHasMore
    ]);
    React.useEffect(function() {
        if (currentSongRequest == null && songRequests != null && playlist != null) {
            nextSongRequest();
        }
    }, [
        currentSongRequest,
        songRequests,
        playlist,
        nextSongRequest
    ]);
    var appendSongRequest = React.useCallback(function(songRequest) {
        setSongRequests(function(prev) {
            return _to_consumable_array(prev !== null && prev !== void 0 ? prev : []).concat([
                songRequest
            ]);
        });
    }, [
        setSongRequests
    ]);
    var updateVolumeSetting = useDebouncedCallback(function(volume) {
        if (channel == null || settings == null) {
            return;
        }
        updateSongRequestSettings(channel._id, {
            volume: volume
        });
    }, 2000);
    var handleVolumeChange = React.useCallback(function(volume) {
        var updatePlayer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var newVolume = Math.floor(volume);
        if (updatePlayer) {
            var _playerRef_current;
            (_playerRef_current = playerRef.current) === null || _playerRef_current === void 0 ? void 0 : _playerRef_current.volume(newVolume);
        }
        setSettings(function(prev) {
            return prev != null ? _object_spread_props(_object_spread({}, prev), {
                volume: newVolume
            }) : null;
        });
        updateVolumeSetting(newVolume);
    }, [
        updateVolumeSetting
    ]);
    React.useEffect(function() {
        var songRequestSkip = function songRequestSkip(param) {
            var item = param.item;
            if (item._id !== (currentSongRequest === null || currentSongRequest === void 0 ? void 0 : currentSongRequest._id)) {
                return;
            }
            nextSongRequest();
            notification(intl.formatMessage({
                id: "/+Y8wU",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Song skipped"
                    }
                ]
            }), {
                icon: /*#__PURE__*/ _jsx(Icon, {
                    p: 1,
                    as: FontAwesomeIcon,
                    icon: faForwardStep
                })
            });
        };
        var songRequestPause = function songRequestPause() {
            setIsPlaying(false);
            notification(intl.formatMessage({
                id: "kxgbgD",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Song paused"
                    }
                ]
            }), {
                icon: /*#__PURE__*/ _jsx(Icon, {
                    p: 1,
                    as: FontAwesomeIcon,
                    icon: faPause
                })
            });
        };
        var songRequestPlay = function songRequestPlay() {
            setIsPlaying(true);
            notification(intl.formatMessage({
                id: "70xHKn",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Song playing"
                    }
                ]
            }), {
                icon: /*#__PURE__*/ _jsx(Icon, {
                    p: 1,
                    as: FontAwesomeIcon,
                    icon: faPlay
                })
            });
        };
        var songRequestQueueClear = function songRequestQueueClear() {
            setSongRequests([]);
            notification(intl.formatMessage({
                id: "C6LgIi",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Queue cleared"
                    }
                ]
            }), {
                icon: /*#__PURE__*/ _jsx(Icon, {
                    p: 1,
                    as: FontAwesomeIcon,
                    icon: faTrash
                })
            });
        };
        var songRequestVolume = function songRequestVolume(param) {
            var volume = param.volume;
            if (settings == null || volume === settings.volume) {
                return;
            }
            handleVolumeChange(volume, true);
            notification(intl.formatMessage({
                id: "tsrgNM",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Volume set to "
                    },
                    {
                        type: 1,
                        value: "volume"
                    }
                ]
            }, {
                volume: volume
            }), {
                icon: /*#__PURE__*/ _jsx(Icon, {
                    p: 1,
                    as: FontAwesomeIcon,
                    icon: faVolumeHigh
                })
            });
        };
        var songRequestQueueAdd = function songRequestQueueAdd(param) {
            var item = param.item;
            if (pendingCurrentSongRequest != null && serializeSongTrackId(item) === serializeSongTrackId(pendingCurrentSongRequest)) {
                return;
            }
            appendSongRequest(item);
            notification(intl.formatMessage({
                id: "gTvcp7",
                defaultMessage: [
                    {
                        type: 0,
                        value: 'Song "'
                    },
                    {
                        type: 1,
                        value: "itemTrackTitle"
                    },
                    {
                        type: 0,
                        value: '" added to queue'
                    }
                ]
            }, {
                itemTrackTitle: item.track.title
            }), {
                icon: /*#__PURE__*/ _jsx(Icon, {
                    p: 1,
                    as: FontAwesomeIcon,
                    icon: faMusic
                })
            });
        };
        var songRequestQueueRemove = function songRequestQueueRemove(param) {
            var item = param.item;
            if (item._id === (currentSongRequest === null || currentSongRequest === void 0 ? void 0 : currentSongRequest._id)) {
                nextSongRequest();
                return;
            }
            setSongRequests(function(prev) {
                var prevIndex = prev === null || prev === void 0 ? void 0 : prev.findIndex(function(song) {
                    return song._id === item._id;
                });
                // only show notification if the song was in the queue
                if (prevIndex != null && prevIndex >= 0) {
                    notification(intl.formatMessage({
                        id: "aVPAOL",
                        defaultMessage: [
                            {
                                type: 0,
                                value: 'Song "'
                            },
                            {
                                type: 1,
                                value: "trackTitle"
                            },
                            {
                                type: 0,
                                value: '" removed from queue'
                            }
                        ]
                    }, {
                        trackTitle: item.track.title
                    }), {
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            p: 1,
                            as: FontAwesomeIcon,
                            icon: faTrash
                        })
                    });
                }
                var _prev_filter;
                return (_prev_filter = prev === null || prev === void 0 ? void 0 : prev.filter(function(song) {
                    return song._id !== item._id;
                })) !== null && _prev_filter !== void 0 ? _prev_filter : [];
            });
        };
        var songRequestQueuePromote = function songRequestQueuePromote(param) {
            var item = param.item;
            setSongRequests(function(prev) {
                if (prev == null) {
                    return [
                        item
                    ];
                }
                var newSongRequests = prev.filter(function(song) {
                    return song._id !== item._id;
                });
                return [
                    item
                ].concat(_to_consumable_array(newSongRequests)).sort(function(a, b) {
                    return a._position - b._position;
                });
            });
            if (item._position === 1) {
                notification(intl.formatMessage({
                    id: "dMWt6W",
                    defaultMessage: [
                        {
                            type: 0,
                            value: 'Song "'
                        },
                        {
                            type: 1,
                            value: "trackTitle"
                        },
                        {
                            type: 0,
                            value: '" promoted to top of queue'
                        }
                    ]
                }, {
                    trackTitle: item.track.title
                }), {
                    icon: /*#__PURE__*/ _jsx(Icon, {
                        p: 1,
                        as: FontAwesomeIcon,
                        icon: faArrowUp
                    })
                });
            }
        };
        if (socketClient == null) {
            return;
        }
        socketClient.on('songRequestSkip', songRequestSkip);
        socketClient.on('songRequestPause', songRequestPause);
        socketClient.on('songRequestQueueAdd', songRequestQueueAdd);
        socketClient.on('songRequestQueueClear', songRequestQueueClear);
        socketClient.on('songRequestQueueRemove', songRequestQueueRemove);
        socketClient.on('songRequestQueuePromote', songRequestQueuePromote);
        socketClient.on('songRequestVolume', songRequestVolume);
        socketClient.on('songRequestPlay', songRequestPlay);
        return function() {
            socketClient.off('songRequestSkip', songRequestSkip);
            socketClient.off('songRequestPause', songRequestPause);
            socketClient.off('songRequestQueueAdd', songRequestQueueAdd);
            socketClient.off('songRequestQueueClear', songRequestQueueClear);
            socketClient.off('songRequestQueueRemove', songRequestQueueRemove);
            socketClient.off('songRequestQueuePromote', songRequestQueuePromote);
            socketClient.off('songRequestVolume', songRequestVolume);
            socketClient.off('songRequestPlay', songRequestPlay);
        };
    }, [
        intl,
        song,
        settings,
        socketClient,
        pendingCurrentSongRequest,
        nextSongRequest,
        appendSongRequest,
        setSongRequests,
        notification,
        handleVolumeChange,
        setIsPlaying,
        currentSongRequest === null || currentSongRequest === void 0 ? void 0 : currentSongRequest._id
    ]);
    React.useEffect(function() {
        var handleTogglePlayPause = function handleTogglePlayPause() {
            setIsPlaying(!isPlaying);
        };
        var handleNextSong = function handleNextSong() {
            nextSongRequest();
        };
        var handleVolumeUp = function handleVolumeUp() {
            setSettings(function(settings) {
                return settings != null ? _object_spread_props(_object_spread({}, settings), {
                    volume: Math.min(100, settings.volume + 10)
                }) : null;
            });
        };
        var handleVolumeDown = function handleVolumeDown() {
            setSettings(function(settings) {
                return settings != null ? _object_spread_props(_object_spread({}, settings), {
                    volume: Math.max(0, settings.volume - 10)
                }) : null;
            });
        };
        nativeEvents.on(NativeEventNames.AUTODJ_TOGGLE_PLAY_PAUSE, handleTogglePlayPause);
        nativeEvents.on(NativeEventNames.AUTODJ_SKIP, handleNextSong);
        nativeEvents.on(NativeEventNames.AUTODJ_VOLUME_UP, handleVolumeUp);
        nativeEvents.on(NativeEventNames.AUTODJ_VOLUME_DOWN, handleVolumeDown);
        return function() {
            nativeEvents.off(NativeEventNames.AUTODJ_TOGGLE_PLAY_PAUSE, handleTogglePlayPause);
            nativeEvents.off(NativeEventNames.AUTODJ_SKIP, handleNextSong);
            nativeEvents.off(NativeEventNames.AUTODJ_VOLUME_UP, handleVolumeUp);
            nativeEvents.off(NativeEventNames.AUTODJ_VOLUME_DOWN, handleVolumeDown);
        };
    }, [
        isPlaying,
        nextSongRequest,
        setIsPlaying
    ]);
    React.useEffect(function() {
        if (isPlaying && currentSongRequest != null) {
            sendNativeEvent({
                name: NativeEventNames.AUTODJ_NOW_PLAYING,
                data: currentSongRequest
            });
        } else if (!isPlaying) {
            sendNativeEvent({
                name: NativeEventNames.AUTODJ_STOP_PLAYING,
                data: null
            });
        }
    }, [
        currentSongRequest,
        isPlaying
    ]);
    var handleDragEnd = React.useCallback(function(result) {
        var destination = result.destination, source = result.source;
        if (channel == null || destination == null || source == null || source.index === destination.index || songRequests == null) {
            return;
        }
        var requests = songRequests !== null && songRequests !== void 0 ? songRequests : [];
        var _requests_splice = _sliced_to_array(requests.splice(source.index, 1), 1), removed = _requests_splice[0];
        requests.splice(destination.index, 0, removed);
        setSongRequests(_to_consumable_array(requests));
        reorderSongRequestQueue(channel._id, requests.map(function(song) {
            return song._id;
        }));
    }, [
        channel,
        songRequests,
        setSongRequests
    ]);
    var removeSongRequest = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (channel == null || selectedSong == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        deleteSongRequest(channel._id, selectedSong._id)
                    ];
                case 1:
                    _state.sent();
                    setSongRequests(function(prev) {
                        var _prev_filter;
                        return (_prev_filter = prev === null || prev === void 0 ? void 0 : prev.filter(function(song) {
                            return song._id !== selectedSong._id;
                        })) !== null && _prev_filter !== void 0 ? _prev_filter : [];
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        channel,
        selectedSong,
        setSongRequests
    ]);
    function addSongRequest(url) {
        return _addSongRequest.apply(this, arguments);
    }
    function _addSongRequest() {
        _addSongRequest = _async_to_generator(function(url) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null || songRequests == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            createSongRequest(channel._id, url)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _addSongRequest.apply(this, arguments);
    }
    var toggleCurrentSongRequestInPlaylist = React.useCallback(function() {
        if (channel == null || currentSongRequest == null || currentSongRequestPlaylistItemLoading) {
            return;
        }
        setCurrentSongRequestPlaylistItemLoading(true);
        if (currentSongRequestPlaylistItem != null) {
            setPlaylist(function(prev) {
                var _prev_filter;
                return (_prev_filter = prev === null || prev === void 0 ? void 0 : prev.filter(function(song) {
                    return song._id !== currentSongRequest._id;
                })) !== null && _prev_filter !== void 0 ? _prev_filter : [];
            });
            deletePlaylistItem(channel._id, currentSongRequestPlaylistItem._id).then(function() {
                return setCurrentSongRequestPlaylistItem(null);
            }).finally(function() {
                return setCurrentSongRequestPlaylistItemLoading(false);
            });
        } else {
            setPlaylistEmpty(false);
            createPlaylistItem(channel._id, currentSongRequest.track.url).then(function(item) {
                return setCurrentSongRequestPlaylistItem(item);
            }).finally(function() {
                return setCurrentSongRequestPlaylistItemLoading(false);
            });
        }
    }, [
        channel,
        currentSongRequest,
        currentSongRequestPlaylistItem,
        currentSongRequestPlaylistItemLoading
    ]);
    var handleSongRequestDelete = React.useCallback(function(song) {
        deleteSongRequestModal.onOpen();
        setSelectedSong(song);
    }, [
        deleteSongRequestModal
    ]);
    var handlePlaylistItemDelete = React.useCallback(function(song) {
        setPlaylist(function(prev) {
            var _prev_filter;
            return (_prev_filter = prev === null || prev === void 0 ? void 0 : prev.filter(function(item) {
                return item._id !== song._id;
            })) !== null && _prev_filter !== void 0 ? _prev_filter : [];
        });
    }, []);
    var previousSongRequest = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _songRequestHistory, newCurrentSongRequest, newSongRequestHistory, songRequest, songRequestQueueItem, _;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (channel == null || songRequestHistory.length === 0 || currentSongRequest == null || pendingCurrentSongRequest != null) {
                        return [
                            2
                        ];
                    }
                    _songRequestHistory = _to_array(songRequestHistory), newCurrentSongRequest = _songRequestHistory[0], newSongRequestHistory = _songRequestHistory.slice(1);
                    setSongRequests(function(prev) {
                        return [
                            currentSongRequest
                        ].concat(_to_consumable_array(prev !== null && prev !== void 0 ? prev : []));
                    });
                    setPendingCurrentSongRequest(newCurrentSongRequest);
                    setSongRequestHistory(newSongRequestHistory);
                    setCurrentSongRequestPlaylistItem(null);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        createSongRequest(channel._id, newCurrentSongRequest.track.url)
                    ];
                case 2:
                    songRequest = _state.sent();
                    return [
                        4,
                        playSongRequestQueueItem(channel._id, songRequest._id)
                    ];
                case 3:
                    songRequestQueueItem = _state.sent();
                    setPendingCurrentSongRequest(null);
                    setCurrentSongRequest(songRequestQueueItem);
                    return [
                        3,
                        5
                    ];
                case 4:
                    _ = _state.sent();
                    setPendingCurrentSongRequest(null);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        channel,
        currentSongRequest,
        pendingCurrentSongRequest,
        setSongRequests,
        songRequestHistory
    ]);
    var toggleSongRequestEnabled = React.useCallback(function() {
        if (channel == null || settings == null) {
            return;
        }
        var enabled = !(settings === null || settings === void 0 ? void 0 : settings.enabled);
        updateSongRequestSettings(channel === null || channel === void 0 ? void 0 : channel._id, {
            enabled: enabled
        });
        setSettings(_object_spread_props(_object_spread({}, settings), {
            enabled: enabled
        }));
    }, [
        channel,
        settings
    ]);
    React.useEffect(function() {
        setPosition(0);
    }, [
        currentSongRequest
    ]);
    var _settings_volume;
    var volume = (_settings_volume = settings === null || settings === void 0 ? void 0 : settings.volume) !== null && _settings_volume !== void 0 ? _settings_volume : 50;
    useCurrentSongRequestOutputFile(song);
    React.useEffect(function() {
        if (channel == null || song == null || currentSongRequestPlaylistItem != null || currentSongRequestPlaylistItemLoading) {
            return;
        }
        setCurrentSongRequestPlaylistItemLoading(true);
        getPlaylist(channel._id, {
            q: song.track.url
        }).then(function(param) {
            var playlistItems = param.playlist;
            var playlistItem = playlistItems.find(function(item) {
                return item.track.providerId === song.track.providerId && item.track.provider === song.track.provider;
            });
            if (playlistItem != null) {
                setCurrentSongRequestPlaylistItem(playlistItem);
            }
        }).finally(function() {
            return setCurrentSongRequestPlaylistItemLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel,
        song === null || song === void 0 ? void 0 : song.track.url
    ]);
    var shufflePlaylist = React.useCallback(function() {
        if (channel == null || isShuffling) {
            return;
        }
        setIsShuffling(true);
        loadPlaylist({
            seed: Date.now()
        }).finally(function() {
            return setIsShuffling(false);
        });
    }, [
        channel,
        isShuffling,
        loadPlaylist
    ]);
    var handlePlayerToggle = React.useCallback(function() {
        if (isPlaying) {
            var _playerRef_current;
            (_playerRef_current = playerRef.current) === null || _playerRef_current === void 0 ? void 0 : _playerRef_current.pause();
        } else {
            var _playerRef_current1;
            (_playerRef_current1 = playerRef.current) === null || _playerRef_current1 === void 0 ? void 0 : _playerRef_current1.play();
        }
    }, [
        isPlaying,
        playerRef
    ]);
    var hasMoreSongs = React.useMemo(function() {
        return songRequests != null && songRequests.length > 0 || playlist != null && playlist.length > 0;
    }, [
        songRequests,
        playlist
    ]);
    React.useEffect(function() {
        var updateBannerBottom = function updateBannerBottom() {
            if (bannerRef.current == null) {
                return;
            }
            setBannerBottom(bannerRef.current.getBoundingClientRect().bottom);
        };
        updateBannerBottom();
        window.addEventListener('resize', updateBannerBottom);
        return function() {
            return window.removeEventListener('resize', updateBannerBottom);
        };
    }, [
        bannerRef,
        song
    ]);
    var bgGradient = React.useMemo(function() {
        var _song_track;
        if ((song === null || song === void 0 ? void 0 : (_song_track = song.track) === null || _song_track === void 0 ? void 0 : _song_track.thumbnailAccentColor) == null) {
            return undefined;
        }
        return "linear(to-b, ".concat(hex2rgba(song.track.thumbnailAccentColor, 0.75), ", backgroundSecondary ").concat(bannerBottom + 100, "px, backgroundSecondary)");
    }, [
        song,
        bannerBottom
    ]);
    var handleErrorInternal = React.useCallback(function(error) {
        // TODO: figure out why this needs a timeout
        setTimeout(function() {
            var _nextSongRequestRef_current;
            return (_nextSongRequestRef_current = nextSongRequestRef.current) === null || _nextSongRequestRef_current === void 0 ? void 0 : _nextSongRequestRef_current.call(nextSongRequestRef);
        }, 500);
        if (error != null && (typeof error === "undefined" ? "undefined" : _type_of(error)) === 'object' && 'data' in error && typeof error.data === 'number') {
            switch(error.data){
                case 2:
                    notification(intl.formatMessage({
                        id: "xNITPx",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Invalid Video ID"
                            }
                        ]
                    }), {
                        status: 'error'
                    });
                    return;
                case 3:
                    notification(intl.formatMessage({
                        id: "uNZv9X",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Does not support HTML5 Player"
                            }
                        ]
                    }), {
                        status: 'error'
                    });
                    return;
                case 100:
                    notification(intl.formatMessage({
                        id: "pU+Juk",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Video not found"
                            }
                        ]
                    }), {
                        status: 'error'
                    });
                    return;
                case 101:
                case 150:
                    notification(intl.formatMessage({
                        id: "PP7UvQ",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Video not embeddable"
                            }
                        ]
                    }), {
                        status: 'error'
                    });
                    return;
            }
        }
        notification(intl.formatMessage({
            id: "wUkYv5",
            defaultMessage: [
                {
                    type: 0,
                    value: "An error occurred loading the item"
                }
            ]
        }), {
            status: 'error'
        });
    }, [
        intl,
        nextSongRequestRef,
        notification
    ]);
    React.useEffect(function() {
        handleErrorRef.current = handleErrorInternal;
    }, [
        handleErrorRef,
        handleErrorInternal
    ]);
    var handleError = React.useCallback(function(err) {
        if (handleErrorRef.current != null) {
            handleErrorRef.current(err);
        }
    }, [
        handleErrorRef
    ]);
    var _useBreakpointValue;
    var isDraggable = (_useBreakpointValue = useBreakpointValue({
        base: false,
        sm: true
    })) !== null && _useBreakpointValue !== void 0 ? _useBreakpointValue : true;
    var handlePause = React.useCallback(function() {
        setIsPlaying_(false);
    }, [
        setIsPlaying_
    ]);
    var handleBuffer = React.useCallback(function() {
        setIsBuffering(true);
    }, [
        setIsBuffering
    ]);
    var handleBufferEnd = React.useCallback(function() {
        setIsBuffering(false);
    }, [
        setIsBuffering
    ]);
    var handleEnded = React.useCallback(function() {
        nextSongRequest();
    }, [
        nextSongRequest
    ]);
    var handlePlay = React.useCallback(function() {
        setIsPlaying_(true);
    }, [
        setIsPlaying_
    ]);
    var handleVolume = React.useCallback(function(volume) {
        handleVolumeChange(volume, false);
    }, [
        handleVolumeChange
    ]);
    var handlePosition = React.useCallback(function(position) {
        setPosition(position);
    }, [
        setPosition
    ]);
    var handleDuration = React.useCallback(function(duration) {
        setDuration(duration);
    }, [
        setDuration
    ]);
    var _song_track_title, _settings_enabled;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            paddingBottom: 0,
            minHeight: windowHeight,
            marginBottom: 0
        },
        _dark: {
            backgroundImage: bgGradient
        },
        position: "relative",
        flex: 1,
        gap: 0,
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: isPlaying && song != null ? intl.formatMessage({
                    id: "jAjgHu",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Song Requests - Playing "
                        },
                        {
                            type: 1,
                            value: "trackTitle"
                        }
                    ]
                }, {
                    trackTitle: (_song_track_title = song.track.title) !== null && _song_track_title !== void 0 ? _song_track_title : ''
                }) : intl.formatMessage({
                    id: "3s3LJl",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Song Requests"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: intl.formatMessage({
                    id: "LKafAE",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Manage your song requests"
                        }
                    ]
                }),
                display: {
                    base: 'none',
                    md: 'block'
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "3s3LJl",
                    defaultMessage: "Song Requests"
                })
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                ref: bannerRef,
                gap: {
                    base: 6,
                    md: 12
                },
                display: song == null ? 'none' : 'flex',
                flexDirection: {
                    base: 'column',
                    md: 'row'
                },
                children: [
                    song != null ? /*#__PURE__*/ _jsx(PlayerEmbed, {
                        song: song,
                        isPlaying: isPlaying,
                        ref: playerRef,
                        volume: muted ? 0 : volume,
                        panelProps: {
                            flex: {
                                base: undefined,
                                md: 1
                            },
                            padding: 0,
                            overflow: 'hidden',
                            boxShadow: 'base',
                            borderWidth: 0
                        },
                        onError: handleError,
                        onPause: handlePause,
                        onBuffer: handleBuffer,
                        onBufferEnd: handleBufferEnd,
                        onEnded: handleEnded,
                        onPlay: handlePlay,
                        onVolume: handleVolume,
                        onSeek: handlePosition,
                        onDuration: handleDuration
                    }) : null,
                    /*#__PURE__*/ _jsx(CurrentSongRequestDescription, {
                        flex: (song === null || song === void 0 ? void 0 : song.track.provider) === SongRequestProvider.SOUNDCLOUD ? 2 : 1,
                        song: song,
                        isPlaying: isPlaying,
                        playerPosition: position,
                        isCurrentSongRequestFromPlaylist: currentSongRequestPlaylistItem != null
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Box, {
                flex: 1,
                display: "flex",
                flexDir: "column",
                position: "relative",
                children: [
                    /*#__PURE__*/ _jsx(SongRequestsTable, {
                        isDraggable: isDraggable,
                        songRequests: songRequests,
                        dragPortalRef: portalRef,
                        playlist: playlist,
                        onPlaylistItemDelete: handlePlaylistItemDelete,
                        onSongRequestDelete: handleSongRequestDelete,
                        handleDragEnd: handleDragEnd,
                        tablePanelProps: {
                            borderBottomRadius: 'none',
                            borderBottom: 'none',
                            flex: 1
                        },
                        afterControlsElement: /*#__PURE__*/ _jsx(SongSettingsMenu, {
                            isShuffling: isShuffling,
                            onEditPlaylist: function() {
                                return navigate(WebRoutes.SONG_REQUESTS_PLAYLIST);
                            },
                            onAddSongRequest: addSongRequestModal.onOpen,
                            songRequestEnabled: (_settings_enabled = settings === null || settings === void 0 ? void 0 : settings.enabled) !== null && _settings_enabled !== void 0 ? _settings_enabled : false,
                            toggleSongRequestEnabled: toggleSongRequestEnabled,
                            onClearQueue: clearQueueModal.onOpen,
                            onShuffle: shufflePlaylist,
                            onEditSettings: function() {
                                return navigate(WebRoutes.SONG_REQUESTS_SETTINGS);
                            },
                            children: /*#__PURE__*/ _jsx(MenuButton, {
                                as: IconButton,
                                "aria-label": intl.formatMessage({
                                    id: "9GvlpZ",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Open Settings"
                                        }
                                    ]
                                }),
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faEllipsisV
                                })
                            })
                        }),
                        onAddSongRequest: addSongRequestModal.onOpen
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        style: {
                            position: 'absolute'
                        },
                        ref: portalRef
                    }),
                    /*#__PURE__*/ _jsx(SongControls, {
                        position: "sticky",
                        bottom: 0,
                        borderLeftWidth: 1,
                        borderRightWidth: 1,
                        borderColor: "borderSecondary",
                        backgroundColor: "backgroundPrimary",
                        playerPosition: position,
                        playerDuration: duration,
                        onSeek: function(position) {
                            return onSeek(position);
                        },
                        isMuted: muted,
                        isPlaying: isPlaying,
                        isBuffering: isBuffering,
                        currentSong: song,
                        hasMore: hasMoreSongs,
                        volume: muted ? 0 : volume / 100,
                        hasHistory: songRequestHistory.length > 0,
                        onVolume: function(volume) {
                            return handleVolumeChange(volume * 100);
                        },
                        onNextSong: function() {
                            return nextSongRequest();
                        },
                        onLastSong: function() {
                            return previousSongRequest();
                        },
                        onShuffle: shufflePlaylist,
                        onEditSettings: function() {
                            return navigate(WebRoutes.SONG_REQUESTS_SETTINGS);
                        },
                        onClearQueue: function() {
                            return clearQueueModal.onOpen();
                        },
                        onPlayToggle: handlePlayerToggle,
                        onMuteToggle: function() {
                            return setMuted(function(prev) {
                                return !prev;
                            });
                        },
                        loadingInPlaylist: currentSongRequestPlaylistItemLoading,
                        inPlaylist: currentSongRequestPlaylistItem != null,
                        onToggleInPlaylist: function() {
                            return toggleCurrentSongRequestInPlaylist();
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: deleteSongRequestModal.isOpen,
                onClose: deleteSongRequestModal.onClose,
                onSubmit: removeSongRequest,
                title: intl.formatMessage({
                    id: "bk1sVO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Song Request"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "+EVqwV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to delete this song request?"
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "K3r6DQ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: addSongRequestModal.isOpen,
                onClose: addSongRequestModal.onClose,
                onSubmit: addSongRequest,
                title: intl.formatMessage({
                    id: "hGiby8",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add Song Request"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "y0/Win",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter the song you want to request"
                        }
                    ]
                }),
                input: {
                    placeholder: intl.formatMessage({
                        id: "b6C1lG",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Song name or URL"
                            }
                        ]
                    }),
                    variant: 'filled'
                },
                submitText: intl.formatMessage({
                    id: "p1P+hQ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Request"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: clearQueueModal.isOpen,
                onClose: clearQueueModal.onClose,
                onSubmit: deleteSongRequestQueue,
                title: intl.formatMessage({
                    id: "HC7JC0",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Clear Song Request Queue"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "W1mjIC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to clear the song request queue?"
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "qfajZz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Clear Queue"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: (settings === null || settings === void 0 ? void 0 : settings.enabled) === false && !closedSongRequestDisabledModal,
                onClose: function() {
                    return setClosedSongRequestDisabledModal(true);
                },
                onSubmit: function() {
                    return toggleSongRequestEnabled();
                },
                title: intl.formatMessage({
                    id: "+85n7t",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Song Requests Disabled"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "o5Ted5",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Song requests are currently disabled, enable them to start requesting songs."
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "TqSTI0",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enable"
                        }
                    ]
                })
            })
        ]
    });
}
export default SongRequests;
